'use client';

import { Row } from '@tanstack/react-table';
import { Edit, MoreHorizontal, Trash } from 'lucide-react';

import { Button } from '#/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '#/components/ui/dropdown-menu';

import { useTranslation } from '#/contexts/useTranslation';
import { WatcherAddressInfo } from '#/data/v1/useWatcherAddressList';
import { useState } from 'react';
import { TableRowActionsEditDialog } from './staking-addresses-table-row-actions-edit-dialog';
import { TableRowActionsRemoveDialog } from './staking-addresses-table-row-actions-remove-dialog';

interface TableRowActionsProps {
  row: Row<WatcherAddressInfo>;
}

export function TableRowActions({ row }: TableRowActionsProps) {
  const translation = useTranslation(
    translation => translation.PortfolioDashboard.ManageYourAddresses
  );

  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isEditAddressOpen, setIsEditAddressOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
          >
            <MoreHorizontal className="h-4 w-4" />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={() => setIsEditAddressOpen(true)}>
            <Edit className="mr-2 h-3.5 w-3.5" />
            {translation.EditAddress.ButtonLabel}
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setIsDeleteOpen(true)}>
            <Trash className="mr-2 h-3.5 w-3.5" />
            {translation.RemoveAddress.ButtonLabel}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <TableRowActionsEditDialog
        originalRow={row.original}
        open={isEditAddressOpen}
        onOpenChange={setIsEditAddressOpen}
      />
      <TableRowActionsRemoveDialog
        originalRow={row.original}
        open={isDeleteOpen}
        onOpenChange={setIsDeleteOpen}
      />
    </>
  );
}
